
import { defineComponent } from 'vue';
import AProgress from 'ant-design-vue/es/progress';

export default defineComponent({
  components: {
    AProgress,
  },
  props: {
    showInfo: {
      type: Boolean,
      required: false,
    },
    percent: {
      type: Number,
      required: false,
    },
    strokeColor: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    size: {
      type: [Number, String],
      required: false,
    },
  },
});
